import React from 'react';
import {Box,} from "@material-ui/core"
import PowerIcon from '@material-ui/icons/Power';
import PowerOffIcon from '@material-ui/icons/PowerOff';
import {ActiveState} from "./ActiveState";
import theme from "../styles/theme";

const setActiveIconWithPaused = (status) => {
    return (
        <Box textAlign={'center'}>
            {status === ActiveState.ACTIVE ? (
                <PowerIcon fontSize="large" style={{color: theme.palette.success.main}}/>
            ) : status === ActiveState.PAUSED ? (
                <PowerIcon fontSize="large" style={{color: theme.palette.warning.main}}/>
            ) : (
                <PowerOffIcon fontSize="large" style={{color: theme.palette.error.main}}/>
            )
            }
        </Box>
    )
};

export default setActiveIconWithPaused;